var map = {
	"./default_bg_1.png": 687,
	"./default_bg_1_2.png": 688,
	"./default_bg_1_3.png": 689,
	"./default_bg_1_4.png": 690,
	"./default_bg_1_5.png": 691,
	"./default_bg_1_6.png": 692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1855;